import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from 'src/app/dashboards/services/data.service';
import { AuthenticationResult } from '../../models/authentication-result';
import { Navigation } from '../../models/navigation';
import { UserNotificationResponseDto } from '../../models/responses/user-notification.response';
import { UiStateStore } from '../../store/ui-state-store.service';

@Component({
  selector: 'navigation-dropdown',
  templateUrl: './navigation-dropdown.component.html',
  styleUrls: ['./navigation-dropdown.component.scss'],
})
export class NavigationDropdownComponent implements OnInit {
  @Input('username') userName: string;
  @Input('navigations') navigations: Navigation[];

  user: AuthenticationResult = null;
  userNotifications: UserNotificationResponseDto[];
  unreadCount: number;
  constructor(
    private router: Router,
    private uiState: UiStateStore,
    private dataService: DataService
  ) {}

  ngOnInit() {
    this.uiState.authenticatedUser.subscribe((user) => {
      if (!user) {
        return;
      }

      this.user = user;
    });
  }

  getUserNotifications = () => {
    this.dataService
      .getUserNotifications(this.user.accountId)
      .subscribe((resp) => {
        this.userNotifications = resp;
        this.unreadCount = resp.filter((x) => !x.isRead).length;
      });
  };

  onNavigationClicked(route: string): void {
    this.router.navigate([route]);
  }
}
